module.exports = __webpack_public_path__ + "static/media/sunglasses.0543fef7.svg";